import { useTheme } from '@mui/material';
import { styled } from '@mui/material/styles';

import AtomGrid from '../../../components/atoms/AtomGrid';
import { styleConfigs } from '../../../components/resources/styleConfigs';
import palette from '../../../theme/learnerPalette';

export const RootStyled = styled(AtomGrid)(() => ({
  height: styleConfigs.dimensions.height100vh,
  display: 'flex',
  [useTheme().breakpoints.down('md')]: {
    height: styleConfigs.dimensions.height100dvh,
  },
  [useTheme().breakpoints.down('sm')]: {
    height: styleConfigs.dimensions.height100svh,
  },
}));

export const SkipLinkStyled = styled('a')(() => ({
  position: 'fixed',
  left: styleConfigs.marginPadding.custom8,
  top: styleConfigs.marginPadding.custom8,
  zIndex: 13000,
  padding: `${styleConfigs.marginPadding.custom12}px ${styleConfigs.marginPadding.custom16}px`,
  backgroundColor: palette.light.background.prussianBlue,
  color: palette.light.text.white,
  fontWeight: styleConfigs.fonts.weight600,
  textDecoration: 'none',
  borderRadius: styleConfigs.borders.border4,
  transform: 'translateY(-200%)',
  transition: useTheme().transitions.create('transform', {
    duration: useTheme().transitions.duration.shorter,
  }),
  '&:focus': {
    transform: 'translateY(0)',
    outline: `${styleConfigs.borders.border2}px solid ${palette.light.text.white}`,
    outlineOffset: styleConfigs.borders.border2,
  },
}));

export const MainStyled = styled(AtomGrid)(() => ({
  flexGrow: 1,
  overflowY: 'scroll',
  backgroundColor: palette.light.background.alabaster,
  paddingBlock: styleConfigs.marginPadding.custom88,
  paddingInline: styleConfigs.marginPadding.custom16,
  transition: useTheme().transitions.create('padding', {
    duration: useTheme().transitions.duration.complex,
  }),
  [useTheme().breakpoints.up('sm')]: {
    paddingInline: styleConfigs.marginPadding.custom24,
  },
  [useTheme().breakpoints.up('lg')]: {
    paddingTop: styleConfigs.marginPadding.custom116,
    paddingInline: styleConfigs.marginPadding.custom40,
  },
}));
